export const GET_LANGUAGES_START = "GET_LANGUAGES_START";
export const GET_LANGUAGES_FINISH = "GET_LANGUAGES_FINISH";
export const GET_LANGUAGES_ERROR = "GET_LANGUAGES_ERROR";
export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";
